import {
  css,
  DefaultTheme,
  FlattenInterpolation,
  Interpolation,
  ThemedStyledProps,
} from 'styled-components';

/**
 * convert the input to a CSS value argument.  If the input argument is a number,
 * it's assumed that the value is in pixels unless the 'unit' argument is passed
 */
export function cssValue(value: string | number, unit = 'px') {
  if (typeof value === 'string') {
    return value;
  }

  return `${value}${unit}`;
}

/**
 * Many components Blockhead expose a hovering state with a data property since
 * handling the hover state with javascript results in a better experience for
 * accessibility and different devices.  This helper can be used to apply the
 * hover state, for example:
 *
 * ```
 *  whileHovering`
 *    background-color: ${getThemeColor('black')};
 *  `
 * ```
 */
export function whileHovering<P extends object = Record<string, unknown>>(
  first: TemplateStringsArray,
  ...interpolations: Array<Interpolation<ThemedStyledProps<P, DefaultTheme>>>
): FlattenInterpolation<ThemedStyledProps<P, DefaultTheme>> {
  return css`
    &[data-hovered='true'] {
      ${css(first, ...interpolations)}
    }
  `;
}
